/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Male4Inputs */

const en__field_enum_male4 = /** @type {(inputs: _Field_Enum_Male4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Male`)
};

const de__field_enum_male4 = /** @type {(inputs: _Field_Enum_Male4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Männlich`)
};

/**
* | output |
* | --- |
* | "Male" |
*
* @param {_Field_Enum_Male4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_male4 = /** @type {((inputs?: _Field_Enum_Male4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Male4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_male4(inputs)
	return de__field_enum_male4(inputs)
});
export { _field_enum_male4 as "_field_enum_MALE" }